/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Refresh_ErrorInputs */

const en_job_form_slot_generation_refresh_error = /** @type {(inputs: Job_Form_Slot_Generation_Refresh_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The job position could not be reloaded after saving.`)
};

const de_job_form_slot_generation_refresh_error = /** @type {(inputs: Job_Form_Slot_Generation_Refresh_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Stelle konnte nach dem Speichern nicht erneut geladen werden.`)
};

/**
* | output |
* | --- |
* | "The job position could not be reloaded after saving." |
*
* @param {Job_Form_Slot_Generation_Refresh_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_refresh_error = /** @type {((inputs?: Job_Form_Slot_Generation_Refresh_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Refresh_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_refresh_error(inputs)
	return en_job_form_slot_generation_refresh_error(inputs)
});